import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { ConfirmationModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/confirmationModal/ConfirmationModal'
import { TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

type UpdatingSessionsModalityModalProps = {
  visible: boolean
  onRequestClose: () => void
}

const ContentContainer = styled.View(({ theme }) => ({
  gap: theme.spacing['16px'],
  alignItems: 'center',
  width: '100%',
}))

export const UpdatingSessionsModalityModal: FunctionComponent<UpdatingSessionsModalityModalProps> = ({
  visible,
  onRequestClose,
}) => {
  return (
    <ConfirmationModal
      testID={tID('UpdatingSessionsModalityModal')}
      visible={visible}
      onRequestClose={onRequestClose}
      modalContents={
        <ContentContainer>
          <Title size={TitleSize.MEDIUM} text='Updating...' textAlign='center' />{' '}
          <BodyText text="We're working on it. This can take 1 to 5 minutes, so feel free to close this window. If you don't see the changes, try refreshing." />
        </ContentContainer>
      }
      confirmationButtonText='Close'
      onConfirmationButtonPress={onRequestClose}
      showCancel={false}
    />
  )
}
